angular.module('impactx.approval').controller('ApprovalDetailDemandCtrl', ['$scope', 'selectedListItems', 'dataGen',
    '$controller', '$mdDialog', 'ProductSelectionService', '$routeParams', '$redirect', 'ToastService', '$errorHandler', 'SubsequentPurchaseOrderDataService', ApprovalDetailDemandCtrl]);

function ApprovalDetailDemandCtrl($scope, selectedListItems, dataGen, $controller, $mdDialog, ProductSelectionService,
                                  $routeParams, $redirect, ToastService, $errorHandler, SubsequentPurchaseOrderDataService) {
    $controller('ApprovalDetailCtrl', {$scope: $scope, backRoute: $routeParams.messages ? "/approvallistopen" : null});

    var atiId = $routeParams.id;
    
    $scope.getPageData = function() {
        dataGen.getData($scope, {id: atiId}, "/approval/view", function() {
            $scope.handleControlDataForChips();
            setChangeAatFunc();
            $scope.setButtons();
            if ($routeParams.messages) {
                var messages = $routeParams.messages.substring(1, $routeParams.messages.length - 1).split(",");
                if (messages.length > 0 && messages[0].length > 0) {
                    ToastService.openStandardToast($scope.trns["message_" + messages[0].trim()]);
                }
            }
            if ($routeParams.warnings) {
                var warnings = $routeParams.warnings.substring(1, $routeParams.warnings.length - 1).split(",");
                if (warnings.length > 0 && warnings[0].length > 0) {
                    var warningsTranslated = [];
                    for (var i = 0; i < warnings.length; i++) {
                        warningsTranslated.push({warning: $scope.trns["warning_" + warnings[i].trim()]});
                    }
                    $errorHandler.showWarnings(warningsTranslated);
                }
            }
            if ($routeParams.errors) {
                var errors = $routeParams.errors.substring(1, $routeParams.errors.length - 1).split(",");
                if (errors.length > 0 && errors[0].length > 0)
                {
                    var errorsTranslated = [];
                    for (var j = 0; j < errors.length; j++) {
                        errorsTranslated.push({error: $scope.trns["error_" + errors[j].trim()]});
                    }
                    $errorHandler.showErrors(errorsTranslated, null, null, false);
                }
            }
        });
    };

    $scope.getHeaderTable = function() {
        return "deh";
    };

    $scope.getDataForItemAction = function() {
        return {
            DEH_Id: $scope.data.approval.headerId,
            DEI_Ids: $scope.selectedItems,
            type: "dei",
            id: $scope.data.approval.id
        };
    };
    $scope.getDataForCSCAction = function(csc_id, des_id) {
        return {
            DEH_Id: $scope.data.approval.headerId,
            CSC_Id: csc_id,
            DES_Id: des_id,
            type: "des",
            id: $scope.data.approval.id
        };
    };
    $scope.getDataForHeaderAction = function() {
        return {
            DEH_Id: $scope.data.approval.headerId,
            type: "deh",
            id: $scope.data.approval.id
        };
    };
    $scope.getDataForItemActionOneItem = function(item) {
        return {
            DEH_Id: $scope.data.approval.headerId,
            DEI_Ids: [{id: item.id}],
            type: "dei",
            id: $scope.data.approval.id
        };
    };

    $scope.callEditEntryPoint = function(ev) {
        var basketItemId = 0;
        if($scope.selectedItems[0]) {
            basketItemId = $scope.selectedItems[0].id;
        }
        var entryPointGet;
        var entryPointSave;
        var controller;
        if(basketItemId == 0 || $scope.selectedItems[0].isFreeform) {
            entryPointGet = "/approval/editdemandfreeform";
            entryPointSave = "/approval/savedemandfreeformitem";
            controller = "EditFreeFormCtrl";
        }
        else {
            entryPointGet = "/approval/editdemand";
            entryPointSave = "/approval/savedemanditem";
            controller = "EditRequestItemCtrl";
        }

        return $mdDialog.show({
            controller: controller,
            templateUrl: 'shared/requestitem/templates/requestitemdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                itemId: basketItemId,
                headerId: $scope.data.approval.headerId,
                entryPointGet: entryPointGet,
                entryPointSave: entryPointSave,
                changeAATEntryPoint: '/approval/changedemandaatdetail',
                lotId: -1,
                productId: -1,
                readOnly: false,
                materialGroupMappingEntryPoint: "/approval/input/eclassmapping",
                hideOrderData: false,
                headerTable: "DEH",
                contractId: 0
            }
        })
            .then(function() {
                $scope.getPageData();
                $scope.selectedItems = [];
            }, function() {
            });
    };
    $scope.getPageData();

    $scope.changeProduct = function() {
        var contextUsrId = $scope.selectedItems[0].replaceContextUser;
        var approvalReplaceItem = "DEI." + $scope.selectedItems[0].id;
        var config;
        if ($scope.selectedItems[0].allowOCIReplacement) {
            config = {
                title: $scope.trns.replaceProduct,
                locals: {
                    ctxUsrId: contextUsrId,
                    headerListActions: [{
                        action: $scope.changeProductOCIFromList,
                        label: $scope.trns.replaceProductOCI
                    }]
                }
            };
        }
        else {
            config = {
                title: $scope.trns.replaceProduct,
                locals: {
                    ctxUsrId: contextUsrId
                }
            }
        }
        $scope.lastSelectedItems = $scope.selectedItems.slice();
        $scope.selectedItems = [];
        return ProductSelectionService.open(config).then(function(selectedProduct) {
            if (selectedProduct)
            {
                return dataGen.postAsForm($scope, {
                    proId: selectedProduct.id,
                    priId: $scope.lastSelectedItems[0].id
                }, "/approval/replacedemandproduct").then(function(){
                    $redirect.reload();
                });
            }
        });
    };

    $scope.changeProductOCIFromList = function(ev) {
        $scope.changeProductOCI(ev, $scope.lastSelectedItems[0]);
    };

    $scope.changeProductOCIFromDialog = function(ev) {
        return $scope.changeProductOCI(ev, $scope.selectedItems[0]);
    };

    $scope.changeProductOCI = function(ev, item) {
        var contextUserId = item.replaceContextUser;

        return $mdDialog.show({
            controller: 'OCIProductReplaceCatalogSelectionCtrl',
            controllerAs: 'ociProductReplaceCatalogSelectionCtrl',
            templateUrl: 'modules/approval/templates/oci-product-replace-catalog-selection.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                contextUserId: contextUserId,
                approvalItem: "DEI." + item.id,
                currentPath: "approvaldetaildemand/" + $routeParams.id
            }
        });
    };

    $scope.redirectToApprovalModified = function(){
        $redirect.redirectTo(null, '/approvalmodifieddei/'+$scope.selectedItems[0].id);
    };

    var setChangeAatFunc = function() {
        $scope.changeAat = function (aatId, headerId, supplierId, itemId) {
            // the aat is already changed... so get the one from the old settings
            if(impactX.isDefined($scope,"oldApprovalData.approval.aat.selected")) {
                $scope.data.approval.aat.selected = $scope.oldApprovalData.approval.aat.selected;
            }
            $scope.saveData(null, true).then(function(){
                if (angular.isDefined(aatId) && aatId !== null)
                {
                    var params = {
                        atiId: atiId,
                        aatId: aatId,
                        headerId: headerId,
                        suplHeaderId: supplierId,
                        itemId: itemId
                    };
                    dataGen.postAsForm($scope, params, '/approval/changeaat').then(function () {
                        $scope.handleControlDataForChips();
                    });
                }
            });
        }
    };

    $scope.checkAATSelected = function(){
        return true;
    };
    $scope.checkRequireAAT = function(){
        return false;
    };

    $scope.checkAATSelectedSupplier = function(supplier){
        return true
    };
    $scope.checkRequireAATSupplier = function(supplier){
        return false;
    };

    $scope.checkCtrlSelectedHeader = function(ctrlString){
        return checkCtrlSelected(ctrlString, $scope.data.approval);
    };

    var checkCtrlSelected = function(ctrlString, obj){
        return true;
    };

    $scope.checkRequireCtrl = function(ctrlString){
        return false;
    };

    $scope.checkRequireCtrlSupplier = function(ctrlString, supplier){
        return false;
    };

    $scope.checkRequireCtrlItem = function(ctrlString, item){
        return false;
    };

    $scope.showHeaderControl = function(ctrl, type) {
        return ctrl && ($scope.showControl.value || (ctrl.set&&ctrl.set.length>0));
    };

    $scope.showContractControl = function(contractHeader, type) {
        if (contractHeader && contractHeader.control) {
            var ctrl = contractHeader.control[type];
            return ctrl && (($scope.showSupplierControl.value && contractHeader === $scope.selectedContractHeader[0]) ||
                (ctrl.set&&ctrl.set.length>0))
        }
        return false;
    };

    $scope.showCateringDialog = function (event) {

    };

    $scope.changeAddressHeader = function(ev) {
        return $scope.showAddressChangeDialog(ev, "deh", $scope.data.approval.headerId);
    };

    $scope.changeAddressSupplierHeader = function(ev) {
        return $scope.showAddressChangeDialog(ev, "des", $scope.selectedContractHeader[0].supplierHeaderId);
    };

    $scope.changeAddressItem = function(ev) {
        return $scope.showAddressChangeDialog(ev, "dei", $scope.selectedItems[0].id);
    };

    $scope.canEditSPO = function (supplier) {
        return supplier && supplier.canEditSPO;
    };

    $scope.editSPO = function (event, supplier) {
        SubsequentPurchaseOrderDataService.openEditDialog(event, supplier.supplierHeaderId, "des");
    }

    $scope.openSubsequentPurchaseOrderDataDialog = function (event, contractHeader) {
        if ($scope.canEditSPO(contractHeader)) {
            $scope.editSPO(event, contractHeader);
        } else {
            SubsequentPurchaseOrderDataService.openViewDialog(event, 0, contractHeader.supplierHeaderId, 0);
        }
    };
}